import { AuthorCardList } from '@components/Author/AuthorCardList';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { Container } from '@components/Container';
import { Footer } from '@components/Footer';
import { Header } from '@components/Header/Header';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import Head from 'next/head';
import type { ReactElement } from 'react';

export default function AuthorsLandingPage(): ReactElement {
  return (
    <>
      <Head>
        <title>Bulk's Experts provide scientific nutrition & health info</title>
        <meta
          name="title"
          content="Bulk's Experts provide scientific nutrition & health info"
        />
        <meta
          name="description"
          content="Bulk's experts cover a wide range of fields. We tap into their collective wisdom to bring you the best information on training and supplements."
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SERVER_URL}/experts`}
        />
      </Head>
      <Header />
      <Container>
        <Breadcrumbs
          crumbs={[
            { title: 'Home', path: '/' },
            {
              title: 'Science, Health And Nutrition Experts',
              path: '/experts',
            },
          ]}
        />
      </Container>
      <Container as="main" id="main-content" className="mb-12.5">
        <div className="mx-auto my-0 max-w-narrow-page justify-self-center">
          <h1>Bulk Nutrients' Science, Health and Nutrition Experts</h1>
          <Paragraph>
            When it comes to researching, formulating, and testing products,
            Bulk Nutrients has curated a team of accredited sports
            nutritionists, fitness professionals and dieticians.
          </Paragraph>
          <Paragraph>
            Bulk's hand selected team of experts constantly stays up to date
            with latest studies and industry trends to ensure our products meet
            and exceed latest scientific research.
          </Paragraph>
        </div>
        <AuthorCardList />
      </Container>
      <Footer />
    </>
  );
}
